export default __webpack_public_path__ + "static/media/doctor-placeholder-female.49c4df41.jpg";